import axios from 'axios';
import goodNewsService from '../../services/goodNewsService';
import httpGoodNewsService from '../../services/httpGoodNewsService';
import {
    FETCH_SQUIRREL_NEWS_FAILURE,
    FETCH_SQUIRREL_NEWS_REQUEST,
    FETCH_SQUIRREL_NEWS_SUCCESS,
} from '../constants/squirrelNewsTypes';

const fetchSquirrelNewsRequest = () => {
    return {
        type: FETCH_SQUIRREL_NEWS_REQUEST,
    };
};

const fetchSquirrelNewsSuccess = (squirrelNews) => {
    return {
        type: FETCH_SQUIRREL_NEWS_SUCCESS,
        payload: squirrelNews,
    };
};

const fetchSquirrelNewsFailure = (error) => {
    return {
        type: FETCH_SQUIRREL_NEWS_FAILURE,
        payload: error,
    };
};

const fetchSquirrelNews = () => {
    return (dispatch) => {
        dispatch(fetchSquirrelNewsRequest);
        goodNewsService
            .getGoodNews({
                num: 3,
                language: 'de',
            })
            .then((response) => {
                const categories = response.data;
                dispatch(fetchSquirrelNewsSuccess(categories));
            })
            .catch((error) => {
                const errorMsg = error.message;
                dispatch(fetchSquirrelNewsFailure(errorMsg));
            });
    };
};

export default fetchSquirrelNews;
